/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLetterMonth: {
  name: 'letter-month';
  data: string;
} = {
  name: 'letter-month',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 5h2.526l4.393 11.66h.162L16.474 5H19v15h-1.98V9.146h-.129l-4.07 10.832h-1.643l-4.07-10.84h-.127V20H5V5Z" fill="currentColor"/></svg>`,
};
